import type {
  DirectBookingAssignmentFormState,
  TemplateDirectBookingBody,
} from "types/shipment";

export const DEFAULT_ASSIGNMENT_CURRENCY = "CAD";

// Shared by useCarrierExists and the create shipment form, which shows it.
export const CARRIER_CHECK_FAILED_MESSAGE =
  "Could not check the carrier's email. Please try again.";

/*
Restores a saved or posted assignment into the create shipment form. The name is
left empty: the assignee selector resolves it against the network, or checks the
email, exactly as for a typed one. A template saved before the rate was agreed
comes back with no price, so the shipper enters it before posting.
*/
export function getDirectBookingAssignmentFormState(
  body: TemplateDirectBookingBody,
): DirectBookingAssignmentFormState {
  return {
    carrierEmail: body.carrier_email,
    carrierDisplayName: null,
    price: body.price ?? "",
    currency: body.currency ?? DEFAULT_ASSIGNMENT_CURRENCY,
  };
}
